import {clientPostWrapper} from "../api/Api";
import {GET_CHATS_AND_INFLUENCER_DATA, GET_CONVERTED_INFLUENCER_REVENUES} from "../common/constants/routes";

export const getInfluencerData = async (payload) => {
 return clientPostWrapper(GET_CHATS_AND_INFLUENCER_DATA, payload);
}

export const getInfluencerRevenues = async () => {
 return clientPostWrapper(GET_CONVERTED_INFLUENCER_REVENUES);
}